import React, { useEffect } from "react";
import Header from "../../../components/header/Header";

import "./Imprint.scss";

const Imprint = () => {
  useEffect(() => {}, []);

  return (
    <div className="imprint-container">
      <Header showNavigation={false} />
      <div className="imprint-content">
        <div className="imprint-header">
          <h1 className="imprint-title">Imprint</h1>
          <p className="imprint-subtitle">
            Information in accordance with Section 5 TMG
          </p>
        </div>
        <div className="imprint-info">
          <p className="info-heading">Address</p>
          <p className="info-text">
            <strong>Simon Kobler</strong>
            <br />
            Bürgermeister-Wild-Straße 33a
            <br />
            85521 Ottobrunn
            <br />
            Germany
          </p>

          <p className="info-heading">Contact Information</p>
          <p className="info-text">
            <strong>E-Mail:</strong>
            <a href="mailto:portfolio@kobler.me">portfolio@kobler.me</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Imprint;
